import * as types from '../../constants/ActionTypes'
import axios from 'axios'

import registerSchool from 'controllers/school/registerSchool'
import loginAsUser from 'controllers/user/loginAsUser'
import registerUser from 'controllers/user/registerUser'
import getAllClass from 'controllers/class/getAllClass'
import getAllTeacher from 'controllers/teacher/getAllTeacher'
import getAllStudent from 'controllers/student/getAllStudent'
import getUserByToken from 'controllers/user/getUserByToken'
import refreshToken from 'controllers/user/refreshToken'
import resetPassword from 'controllers/user/resetPassword'
import sendPhoneVerification from 'controllers/user/sendPhoneVerification'
import getTradeRecord from 'controllers/school/getTradeRecord'
import getTradeNote from 'controllers/school/getTradeNote'
import updateTradeNote from 'controllers/school/updateTradeNote'
import sendTradeEmail from 'controllers/school/sendTradeEmail'
import getTimetable from 'controllers/school/getTimetable'
import getPermissionGroupList from 'controllers/permission/getPermissionGroupList'
import registerPermissionGroup from 'controllers/permission/registerPermissionGroup'
import addPermissionGroupTeacher from 'controllers/permission/addPermissionGroupTeacher'
import updatePermissionGroupTeacher from 'controllers/permission/updatePermissionGroupTeacher'
import getPermissionGroupDetail from 'controllers/permission/getPermissionGroupDetail'
import deletePermissionGroup from 'controllers/permission/deletePermissionGroup'
import updatePermissionGroup from 'controllers/permission/updatePermissionGroup'
import addPaymentMethod from 'controllers/payment/addPaymentMethod'
import addSubscription from 'controllers/payment/addSubscription'
import getSubscription from 'controllers/payment/getSubscription'
import getPermissionList from 'controllers/permission/getPermissionList'
import confirmTeacher from 'controllers/teacher/confirmTeacher'
import deleteSchool from 'controllers/school/deleteSchool'
import getMonthlyFinance from 'controllers/school/getMonthlyFinance'
export function schoolLoginRequestOut() {
  return {
    type: types.S_LOG_IN
  }
}

export function schoolLoginOk(result) {
  return {
    type: types.S_LOG_IN_OK,
    result: result
  }
}

export function schoolLoginFailed(error) {
  return {
    type: types.S_LOG_IN_FAILED,
    error: error
  }
}

export function schoolLoginAction(params) {
  return function (dispatch) {
    dispatch(schoolLoginRequestOut)
    return loginAsUser(params).then(function(results) {
      dispatch(schoolLoginOk(results.data))
    }).catch(function (error) {
      dispatch(schoolLoginFailed(error))
    })
  }
}

// Billy add school sign up action Nov.07.2017
export function schoolSignupRequestOut() {
  return {
    type: types.S_SIGN_UP
  }
}

export function schoolSignupOk(result) {
  return {
    type: types.S_SIGN_UP_OK,
    result: result
  }
}

export function schoolSignupFailed(error) {
  return {
    type: types.S_SIGN_UP_FAILED,
    error: error
  }
}

export function schoolSignupAction(params) {
  return function (dispatch) {
    dispatch(schoolSignupRequestOut)
    return registerUser(params).then(function(results) {
      dispatch(schoolSignupOk(results.data))
    }).catch(function (error) {
      dispatch(schoolSignupFailed(error))
    })
  }
}

// Billy add create school action Nov.08.2017
export function schoolRegisterRequestOut() {
  return {
    type: types.RGST_SCHOOL
  }
}

export function schoolRegisterRequestOk(result) {
  return {
    type: types.RGST_SCHOOL_OK,
    result: result
  }
}

export function schoolRegisterRequestFailed(error) {
  return {
    type: types.RGST_SCHOOL_FAILED,
    error: error
  }
}

export function schoolRegisterAction(params) {
  return function (dispatch) {
    dispatch(schoolRegisterRequestOut)
    return registerSchool(params).then(function(results) {
      dispatch(schoolRegisterRequestOk(results.data))
    }).catch(function (error) {
      dispatch(schoolRegisterRequestFailed(error))
    })
  }
}

export function getSchoolClassListRequestOut() {
  return {
    type: types.GET_SCH_CLS_LST
  }
}

export function getSchoolClassListOk(result) {
  return {
    type: types.GET_SCH_CLS_LST_OK,
    result: result
  }
}

export function getSchoolClassListFailed(error) {
  return {
    type: types.GET_SCH_CLS_LST_FAILED,
    error: error
  }
}

export function getSchoolClassListAction(schoolId) {
  return function (dispatch) {
    dispatch(getSchoolClassListRequestOut)
    return getAllClass(schoolId).then(function(results) {
      dispatch(getSchoolClassListOk(results.data))
    }).catch(function (error) {
      dispatch(getSchoolClassListFailed(error))
    })
  }
}


export function getSchoolTeacherListRequestOut() {
  return {
    type: types.GET_SCH_TCH_LST
  }
}

export function getSchoolTeacherListOk(result) {
  let list = _.orderBy(result.list, ['id'], ['desc'])
  result.list = list
  return {
    type: types.GET_SCH_TCH_LST_OK,
    result: result
  }
}

export function getSchoolTeacherListFailed(error) {
  return {
    type: types.GET_SCH_TCH_LST_FAILED,
    error: error
  }
}

export function getSchoolTeacherListAction(schoolId) {
  return function (dispatch) {
    dispatch(getSchoolTeacherListRequestOut)
    return getAllTeacher(schoolId).then(function(results) {
      dispatch(getSchoolTeacherListOk(results.data))
    }).catch(function (error) {
      dispatch(getSchoolTeacherListFailed(error))
    })
  }
}

export function getSchoolStudentListRequestOut() {
  return {
    type: types.GET_SCH_STDT_LST
  }
}

export function getSchoolStudentListOk(data) {
  data.list = _.sortBy(data.list, ['sName'])
  return {
    type: types.GET_SCH_STDT_LST_OK,
    result: data
  }
}

export function getSchoolStudentListFailed(error) {
  return {
    type: types.GET_SCH_STDT_LST_FAILED,
    error: error
  }
}

export function getSchoolStudentListAction(schoolId, state) {
  return function (dispatch) {
    dispatch(getSchoolStudentListRequestOut)
    return getAllStudent(schoolId, state).then(function(results) {
      dispatch(getSchoolStudentListOk(results.data))
    }).catch(function (error) {
      dispatch(getSchoolStudentListFailed(error))
    })
  }
}

export function getUserByTokenRequestOut() {
  return {
    type: types.GET_USER_BY_TOKEN
  }
}

export function getUserByTokenOk(result) {
  return {
    type: types.GET_USER_BY_TOKEN_OK,
    result: result
  }
}

export function getUserByTokenFailed(error) {
  return {
    type: types.GET_USER_BY_TOKEN_FAILED,
    error: error
  }
}

export function getUserByTokenAction() {
  return function (dispatch) {
    dispatch(getUserByTokenRequestOut)
    return getUserByToken().then(function(results) {
      dispatch(getUserByTokenOk(results.data))
    }).catch(function (error) {
      dispatch(getUserByTokenFailed(error))
    })
  }
}

export function refreshTokenRequestOut() {
  return {
    type: types.REFRESH_TOKEN
  }
}

export function refreshTokenOk(result) {
  localStorage.setItem('token', result.token);
  return {
    type: types.REFRESH_TOKEN_OK,
    result: result
  }
}

export function refreshTokenFailed(error) {
  return {
    type: types.REFRESH_TOKEN_FAILED,
    error: error
  }
}

export function refreshTokenAction(params) {
  return function (dispatch) {
    dispatch(refreshTokenRequestOut)
    return refreshToken(params).then(function(results) {
      dispatch(refreshTokenOk(results.data))
    }).catch(function (error) {
      dispatch(refreshTokenFailed(error))
    })
  }
}

export function changePasswordRequestOut() {
  return {
    type: types.CHANGE_PASSWD
  }
}

export function changePasswordOk(result) {
  return {
    type: types.CHANGE_PASSWD_OK,
    result: result
  }
}

export function changePasswordFailed(error) {
  return {
    type: types.CHANGE_PASSWD_FAILED,
    error: error
  }
}

export function changePasswordAction(params) {
  return function (dispatch) {
    dispatch(changePasswordRequestOut)
    return resetPassword(params).then(function(results) {
      dispatch(changePasswordOk(results.data))
    }).catch(function (error) {
      dispatch(changePasswordFailed(error))
    })
  }
}

export function sendPhoneVerificationRequestOut() {
  return {
    type: types.SEND_PHONE_VRFCTION
  }
}

export function sendPhoneVerificationOk(result) {
  return {
    type: types.SEND_PHONE_VRFCTION_OK,
    result: result
  }
}

export function sendPhoneVerificationFailed(error) {
  return {
    type: types.SEND_PHONE_VRFCTION_FAILED,
    error: error
  }
}

export function sendPhoneVerificationAction(params) {
  return function (dispatch) {
    dispatch(sendPhoneVerificationRequestOut)
    return sendPhoneVerification(params).then(function(results) {
      dispatch(sendPhoneVerificationOk(results.data))
    }).catch(function (error) {
      dispatch(sendPhoneVerificationFailed(error))
    })
  }
}

export function getSchoolTradeListRequestOut() {
  return {
    type: types.GET_TRADE_LIST
  }
}

export function getSchoolTradeListOk(result) {
  return {
    type: types.GET_TRADE_LIST_OK,
    result: result
  }
}

export function getSchoolTradeListFailed(error) {
  return {
    type: types.GET_TRADE_LIST_FAILED,
    error: error
  }
}

export function getSchoolTradeListAction(schoolId, params) {
  return function (dispatch) {
    dispatch(getSchoolTradeListRequestOut)
    return getTradeRecord(schoolId, params).then(function(results) {
      dispatch(getSchoolTradeListOk(results))
    }).catch(function (error) {
      dispatch(getSchoolTradeListFailed(error))
    })
  }
}

export function getTradeNoteRequestOut() {
  return {
    type: types.GET_TRADE_NOTE
  }
}

export function getTradeNoteOk(result) {
  return {
    type: types.GET_TRADE_NOTE_OK,
    result: result
  }
}

export function getTradeNoteFailed(error) {
  return {
    type: types.GET_TRADE_NOTE_FAILED,
    error: error
  }
}

export function getTradeNoteAction(tradeRecordId) {
  return function (dispatch) {
    dispatch(getTradeNoteRequestOut)
    return getTradeNote(tradeRecordId).then(function(results) {
      dispatch(getTradeNoteOk(results.data))
    }).catch(function (error) {
      dispatch(getTradeNoteFailed(error))
    })
  }
}

export function updateTradeNoteRequestOut() {
  return {
    type: types.UPDATE_TRADE_NOTE
  }
}

export function updateTradeNoteOk(result) {
  return {
    type: types.UPDATE_TRADE_NOTE_OK,
    result: result
  }
}

export function updateTradeNoteFailed(error) {
  return {
    type: types.UPDATE_TRADE_NOTE_FAILED,
    error: error
  }
}

export function updateTradeNoteAction(tradeRecordId, params) {
  return function (dispatch) {
    dispatch(updateTradeNoteRequestOut)
    return updateTradeNote(tradeRecordId, params).then(function(results) {
      dispatch(updateTradeNoteOk(results.data))
    }).catch(function (error) {
      dispatch(updateTradeNoteFailed(error))
    })
  }
}

export function sendTradeEmailRequestOut() {
  return {
    type: types.SEND_TRADE_EMAIL
  }
}

export function sendTradeEmailOk(result) {
  return {
    type: types.SEND_TRADE_EMAIL_OK,
    result: result
  }
}

export function sendTradeEmailFailed(error) {
  return {
    type: types.SEND_TRADE_EMAIL_FAILED,
    error: error
  }
}

export function sendTradeEmailAction(tradeRecordId, params) {
  return function (dispatch) {
    dispatch(sendTradeEmailRequestOut)
    return sendTradeEmail(tradeRecordId, params).then(function(results) {
      dispatch(sendTradeEmailOk(results.data))
    }).catch(function (error) {
      dispatch(sendTradeEmailFailed(error))
    })
  }
}

export function getTimetableRequestOut() {
  return {
    type: types.GET_TIMETABLE
  }
}

export function getTimetableOk(result) {
  return {
    type: types.GET_TIMETABLE_OK,
    result: result
  }
}

export function getTimetableFailed(error) {
  return {
    type: types.GET_TIMETABLE_FAILED,
    error: error
  }
}

export function getTimetableAction(schoolId, params) {
  return function (dispatch) {
    dispatch(getTimetableRequestOut)
    return getTimetable(schoolId, params).then(function(results) {
      dispatch(getTimetableOk(results.data))
    }).catch(function (error) {
      dispatch(getTimetableFailed(error))
    })
  }
}

// Billy add get school group list action -- Nov.28.2017
export function schoolGroupListRequestOut() {
  return {
    type: types.S_GROUP_LIST
  }
}

export function schoolGroupListOk(result) {
  return {
    type: types.S_GROUP_LIST_OK,
    result: result
  }
}

export function schoolGroupListFailed(error) {
  return {
    type: types.S_GROUP_LIST_FAILED,
    error: error
  }
}

export function getSchoolGroupListAction(schoolId) {
  return function (dispatch) {
    dispatch(schoolGroupListRequestOut)
    return getPermissionGroupList(schoolId).then(function(results) {
      dispatch(schoolGroupListOk(results.data))
    }).catch(function (error) {
      dispatch(schoolGroupListFailed(error))
    })
  }
}

// Billy add post school group list action -- NOv.29.2017
export function groupListRegisterRequestOut() {
  return {
    type: types.RGST_GROUP_LIST
  }
}

export function groupListRegisterOk(result) {
  return {
    type: types.RGST_GROUP_LIST_OK,
    result: result
  }
}

export function groupListRegisterFailed(error) {
  return {
    type: types.RGST_GROUP_LIST_FAILED,
    error: error
  }
}

export function groupListRegisterAction(schoolId, params) {
  return function (dispatch) {
    dispatch(groupListRegisterRequestOut)
    return registerPermissionGroup(schoolId, params).then(function(results) {
      dispatch(groupListRegisterOk(results.data))
    }).catch(function (error) {
      dispatch(groupListRegisterFailed(error))
    })
  }
}

// Billy add teacher group edit action -- Nov.29.2017
export function groupListTeacherRequestOut() {
  return {
    type: types.GROUP_LIST_TEACHER
  }
}

export function groupListTeacherOk(result) {
  return {
    type: types.GROUP_LIST_TEACHER_OK,
    result: result
  }
}

export function groupListTeacherFailed(error) {
  return {
    type: types.GROUP_LIST_TEACHER_FAILED,
    error: error
  }
}

export function groupListTeacherAction(schoolId, params) {
  return function (dispatch) {
    dispatch(groupListTeacherRequestOut)
    return addPermissionGroupTeacher(schoolId, params).then(function(results) {
      dispatch(groupListTeacherOk(results.data))
    }).catch(function (error) {
      dispatch(groupListTeacherFailed(error))
    })
  }
}

// Billy add update teacher group list action -- Nov.30.2017
export function updateGroupListTeacherRequestOut() {
  return {
    type: types.UPDATE_GROUP_LIST_TEACHER
  }
}

export function updateGroupListTeacherOk(result) {
  return {
    type: types.UPDATE_GROUP_LIST_TEACHER_OK,
    result: result
  }
}

export function updateGroupListTeacherFailed(error) {
  return {
    type: types.UPDATE_GROUP_LIST_TEACHER_FAILED,
    error: error
  }
}

export function updateGroupListTeacherAction(schoolId, params) {
  return function (dispatch) {
    dispatch(updateGroupListTeacherRequestOut)
    return updatePermissionGroupTeacher(schoolId, params).then(function(results) {
      dispatch(updateGroupListTeacherOk(results.data))
    }).catch(function (error) {
      dispatch(updateGroupListTeacherFailed(error))
    })
  }
}

// Billy add get school group detail action -- Nov.29.2017
export function getGroupDetailRequestOut() {
  return {
    type: types.GET_GROUP_DETAIL
  }
}

export function getGroupDetailOk(result) {
  return {
    type: types.GET_GROUP_DETAIL_OK,
    result: result
  }
}

export function getGroupDetailFailed(error) {
  return {
    type: types.GET_GROUP_DETAIL_FAILED,
    error: error
  }
}

export function getGroupDetailAction(school_group_id) {
  return function (dispatch) {
    dispatch(getGroupDetailRequestOut)
    return getPermissionGroupDetail(school_group_id).then(function(results) {
      dispatch(getGroupDetailOk(results.data))
    }).catch(function (error) {
      dispatch(getGroupDetailFailed(error))
    })
  }
}

// Billy add delete group action -- Nov.30.2017
export function deleteGroupRequestOut() {
  return {
    type: types.DELETE_GROUP
  }
}

export function deleteGroupOk(result) {
  return {
    type: types.DELETE_GROUP_OK,
    result: result
  }
}

export function deleteGroupFailed(error) {
  return {
    type: types.DELETE_GROUP_FAILED,
    error: error
  }
}

export function deleteGroupAction(groupId) {
  return function (dispatch) {
    dispatch(deleteGroupRequestOut)
    return deletePermissionGroup(groupId).then(function(results) {
      dispatch(deleteGroupOk(results.data))
    }).catch(function (error) {
      dispatch(deleteGroupFailed(error))
    })
  }
}

// Billy add update group list -- Nov.30.2017
export function updateGroupListRequestOut() {
  return {
    type: types.UPDATE_GROUP_LIST
  }
}

export function updateGroupListOk(result) {
  return {
    type: types.UPDATE_GROUP_LIST_OK,
    result: result
  }
}

export function updateGroupListFailed(error) {
  return {
    type: types.UPDATE_GROUP_LIST_FAILED,
    error: error
  }
}

export function updateGroupListAction(groupId, params) {
  return function (dispatch) {
    dispatch(updateGroupListRequestOut)
    return updatePermissionGroup(groupId, params).then(function(results) {
      dispatch(updateGroupListOk(results.data))
    }).catch(function (error) {
      dispatch(updateGroupListFailed(error))
    })
  }
}

// Billy add upgrade to premium version action -- Dec.06.2017
export function paymentMethodRequestOut() {
  return {
    type: types.PAYMENT_METHOD
  }
}

export function paymentMethodOk(result) {
  return {
    type: types.PAYMENT_METHOD_OK,
    result: result
  }
}

export function paymentMethodFailed(error) {
  return {
    type: types.PAYMENT_METHOD_FAILED,
    error: error
  }
}

export function paymentMethodAction(params) {
  return function (dispatch) {
    dispatch(paymentMethodRequestOut)
    return addPaymentMethod(params).then(function(results) {
      dispatch(paymentMethodOk(results.data))
    }).catch(function (error) {
      dispatch(paymentMethodFailed(error))
    })
  }
}

// Billy add subscription action -- Dec.06.2017
export function subscriptionRequestOut() {
  return {
    type: types.SUBSCRIPTION
  }
}

export function subscriptionOk(result) {
  return {
    type: types.SUBSCRIPTION_OK,
    result: result
  }
}

export function subscriptionFailed(error) {
  return {
    type: types.SUBSCRIPTION_FAILED,
    error: error
  }
}

export function subscriptionAction(params) {
  return function (dispatch) {
    dispatch(subscriptionRequestOut)
    return addSubscription(params).then(function(results) {
      dispatch(subscriptionOk(results.data))
    }).catch(function (error) {
      dispatch(subscriptionFailed(error))
    })
  }
}

// Billy add get subscription action -- Dec.06.2017
export function getSubscriptionRequestOut() {
  return {
    type: types.GET_SUBSCRIPTION
  }
}

export function getSubscriptionOk(result) {
  return {
    type: types.GET_SUBSCRIPTION_OK,
    result: result
  }
}

export function getSubscriptionFailed(error) {
  return {
    type: types.GET_SUBSCRIPTION_FAILED,
    error: error
  }
}

export function getSubscriptionAction() {
  return function (dispatch) {
    dispatch(getSubscriptionRequestOut)
    return getSubscription().then(function(results) {
      dispatch(getSubscriptionOk(results.data))
    }).catch(function (error) {
      dispatch(getSubscriptionFailed(error))
    })
  }
}

// Billy add get school permission list action -- Nov.29.2017
export function schoolPermissionListRequestOut() {
  return {
    type: types.S_PERMISSION_LIST
  }
}

export function schoolPermissionListOk(result) {
  return {
    type: types.S_PERMISSION_LIST_OK,
    result: result
  }
}

export function schoolPermissionListFailed(error) {
  return {
    type: types.S_PERMISSION_LIST_FAILED,
    error: error
  }
}

export function getSchoolPermissionListAction() {
  return function (dispatch) {
    dispatch(schoolPermissionListRequestOut)
    return getPermissionList().then(function(results) {
      dispatch(schoolPermissionListOk(results.data))
    }).catch(function (error) {
      dispatch(schoolPermissionListFailed(error))
    })
  }
}

// Billy add teacher confirmation action -- Dec.08.2017
export function teacherConfirmationRequestOut() {
  return {
    type: types.TEACHER_CONFIRMATION
  }
}

export function teacherConfirmationOk(result) {
  return {
    type: types.TEACHER_CONFIRMATION_OK,
    result: result
  }
}

export function teacherConfirmationFailed(error) {
  return {
    type: types.TEACHER_CONFIRMATION_FAILED,
    error: error
  }
}

export function teacherConfirmationAction(teacherId, params) {
  return function (dispatch) {
    dispatch(teacherConfirmationRequestOut)
    return confirmTeacher(teacherId, params).then(function(results) {
      dispatch(teacherConfirmationOk(results.data))
    }).catch(function (error) {
      dispatch(teacherConfirmationFailed(error))
    })
  }
}

// Billy add delete school action -- Dec.13.2017
export function deleteSchoolRequestOut() {
  return {
    type: types.DELETE_SCHOOL
  }
}

export function deleteSchoolOk(result) {
  return {
    type: types.DELETE_SCHOOL_OK,
    result: result
  }
}

export function deleteSchoolFailed(error) {
  return {
    type: types.DELETE_SCHOOL_FAILED,
    error: error
  }
}

export function deleteSchoolAction(schoolId) {
  return function (dispatch) {
    dispatch(deleteSchoolRequestOut)
    return deleteSchool(schoolId).then(function(results) {
      dispatch(deleteSchoolOk(results.data))
    }).catch(function (error) {
      dispatch(deleteSchoolFailed(error))
    })
  }
}

export function getSchoolMonthlyFinanceRequestOut() {
  return {
    type: types.GET_MONTHLY_FINANCE
  }
}

export function getSchoolMonthlyFinanceOk(result) {
  return {
    type: types.GET_MONTHLY_FINANCE_OK,
    result: result
  }
}

export function getSchoolMonthlyFinanceFailed(error) {
  return {
    type: types.GET_MONTHLY_FINANCE_FAILED,
    error: error
  }
}

export function getSchoolMonthlyFinanceAction(schoolId, params) {
  return function (dispatch) {
    dispatch(getSchoolMonthlyFinanceRequestOut)
    return getMonthlyFinance(schoolId, params).then(function(results) {
      dispatch(getSchoolMonthlyFinanceOk(results.data))
    }).catch(function (error) {
      dispatch(getSchoolMonthlyFinanceFailed(error))
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/School/SchoolAction.js